var map = {
	"./02.png": 6669,
	"./2993773_git_social media_icon.png": 7535,
	"./Bootstrap.png": 6569,
	"./CSS3.png": 8314,
	"./Git.png": 8441,
	"./GitHub.png": 5910,
	"./HTML.png": 279,
	"./JavaScript.png": 8727,
	"./NextJs.png": 3919,
	"./ReactJs.png": 822,
	"./Sass.png": 9106,
	"./ballon.png": 2041,
	"./email2.png": 2153,
	"./graybalon.png": 786,
	"./main2.png": 2510,
	"./messenger2.png": 3998,
	"./plus-orange.png": 5685,
	"./square-dots-orange.png": 4741,
	"./squareimg.png": 7954,
	"./twobalone.png": 8772,
	"./whatsapp2.png": 6508,
	"./zigzag.png": 2083
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9513;